import { useEffect, useState } from "react";
import { io } from "socket.io-client";
import { useSelector } from "react-redux";
import { baseUrl } from "../helpers/constants";

const SOCKET_SERVER_URL = baseUrl || "http://localhost:5002";

const useSocket = () => {
  const [socket, setSocket] = useState(null);
  const [notifications, setNotifications] = useState([]);

  const { user, token } = useSelector((state) => state.auth);

  useEffect(() => {
    if (!token) {
      console.log("No token available - skipping socket connection");
      return;
    }

    const newSocket = io(SOCKET_SERVER_URL, {
      transports: ["websocket"],
      auth: {
        token: token,
      },
      withCredentials: true,
      autoConnect: true,
    });

    newSocket.on("connect", () => {
      console.log("Socket connected!");

      if (user?.role === "admin") {
        newSocket.emit("join_merchant_room", user.id);
      } else if (user?.role === "admin") {
        newSocket.emit("join_admin_room");
      }
    });

    newSocket.on("connect_error", (err) => {
      console.error("Connection error:", err.message);
    });

    newSocket.on("new_transaction", (message) => {
      setNotifications((prev) => [...prev, message]);
    });

    setSocket(newSocket);

    return () => {
      newSocket.off("connect");
      newSocket.off("connect_error");
      newSocket.off("new_transaction");
      newSocket.disconnect();
    };
  }, [token, user?.id, user?.role]);

  return { socket, notifications };
};

export default useSocket;
